import { render, staticRenderFns } from "./editable.vue?vue&type=template&id=56cdcf0f&scoped=true&"
import script from "./editable.vue?vue&type=script&lang=js&"
export * from "./editable.vue?vue&type=script&lang=js&"
import style0 from "./editable.vue?vue&type=style&index=0&id=56cdcf0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdcf0f",
  null
  
)

export default component.exports